// extracted by mini-css-extract-plugin
export default {"container":"Transaction_container__RbaBX"};